export function uppercaseFirstLetter(str: string) {
  return str[0].toUpperCase() + str.slice(1);
}

export function lowercaseFirstLetter(str: string) {
  return str[0].toLowerCase() + str.slice(1);
}
